import { type BundleConfigItem } from "@jti/fe-common";
import { type IBundleOptionInput } from "@jti/magento";

export const getSingleFlavorBundleProductCartPayload = (
  selectedBundleConfig: BundleConfigItem
): IBundleOptionInput[] | null => {
  const option = selectedBundleConfig.allOptions[0];

  if (!option) {
    return null;
  }

  return [
    {
      id: selectedBundleConfig.optionId,
      quantities: [
        {
          qty: [selectedBundleConfig.qty],
          selection_id: [Number(option.id)],
        },
      ],
      quantity: 0, // Nobody knows what this value stands for, but it's better to leave it hardcoded value zero
      value: [String(option.id)],
    },
  ];
};
